export enum EnumPrescriptionRenewalMedicationsStatus {
    Approved = 1,
    Denied = 2
}
